import { createTRPCClient, httpLink } from "@trpc/client";
import superjson from "superjson";
import type { BackendRouter } from "@puzzleini/backend/router";

export function createBackendClient(
  baseURL: string,
  fetcher: typeof fetch = fetch,
) {
  return createTRPCClient<BackendRouter>({
    links: [
      httpLink({
        url: `${baseURL.replace(/\/$/, "")}/trpc`,
        transformer: superjson,
        fetch: (url, options) =>
          fetcher(url, {
            ...options,
            credentials: "include",
            signal: AbortSignal.any([
              AbortSignal.timeout(15_000),
              ...(options?.signal ? [options.signal] : []),
            ]),
          }),
      }),
    ],
  });
}

